import { takeLatest } from 'redux-saga/effects'
import { handleUploadDocument, handleUploadPersonalDetails } from './modificationHandler'
import { uploadDocument, uploadPersonalDetails } from './modificationSlice'

export function* uploadDocumentSaga() {
  yield takeLatest(uploadDocument.type, handleUploadDocument)
}

export function* uploadPersonalDetailsSaga() {
  yield takeLatest(uploadPersonalDetails.type, handleUploadPersonalDetails)
}
